'use client';

import { Section } from '@/app/(founder)/(home)/_components/section';
import Image from 'next/image';
import SchemaImg from '@/assets/images/home/schema.png';
import { useIsMobile } from '@/hooks/use-mobile';

export const Technology = () => {
    const isMobile = useIsMobile(1000);

    return (
        <Section
            title="Behavioral Science Meets Capital Markets"
            dark
            center={isMobile}
            image={
                <div
                    className={
                        'relative max-w-[320px] h-[40px] max-lg:mb-10 md:max-w-max md:w-[480px] md:h-[62px] flex items-center justify-center mb-4 self-center flex-shrink-0'
                    }
                >
                    <Image
                        src={SchemaImg}
                        layout="contain"
                        alt="schema image"
                    />
                </div>
            }
        >
            <p className="text-sm my-4 font-bold">
                Every piece of content we generate is built on storytelling
                frameworks, decision-making psychology, and market-tested best
                practices. This isn't just automation—it's engineered
                persuasion.
            </p>
        </Section>
    );
};
